<template>
  <div class="mask_main" v-if="show">
    <div class="mask_content">
      <div class="mask_left">
        <div class="search_box">
          <el-input v-model="value" placeholder="注册代码/单位内编号/使用单位/设备编号" />
          <el-button type="primary" icon="el-icon-search" size="small">搜索</el-button>
        </div>
        <div class="company_box">
          <div
            :class="current == index ? 'company_list active' : 'company_list normal'"
            v-for="(item, index) in companyList"
            :key="index"
            @click="tabsChange(index)"
          >
            <div class="title">武汉东湖高新运营发展有限公司</div>
            <div class="desc">项目名称：<span>软件新城1.1期-1</span></div>
            <div class="desc">单位内编号：<span>A8-B-2</span></div>
            <div class="desc">注册代码：<span>31104201192020010046</span></div>
            <div class="desc">设备编号：<span>13G012808</span></div>
          </div>
        </div>
      </div>
      <div class="mask_right">
        <div class="right_title">
          <div class="title_text">电梯详情</div>
          <img @click="closeMsk" class="close" src="@/assets/image/mask_close.png" />
        </div>
        <div class="detail_label">
          <img class="icon" src="@/assets/image/mask_icon.png" />
          电梯信息
        </div>
        <div class="ele_detail">
          <div class="detail_left">
            <div class="detail_info">注册代码：<span>31104201192020010046</span></div>
            <div class="detail_info">设备编号：<span>13G012808</span></div>
            <div class="detail_info">单位内编号：<span>A8-B-2</span></div>
            <div class="detail_info">
              使用单位：<span>武汉东湖高新运营发展有限公司</span>
            </div>
            <div class="detail_info">项目名称：<span>软件新城1.1期-1</span></div>
            <div class="detail_info">
              定位地址：<span>湖北省武汉市洪山区华山街道双城路113号</span>
            </div>
          </div>
          <img class="detail_photo" src="@/assets/zhuapai2.png" />
        </div>
        <div class="detail_label">
          <img class="icon" src="@/assets/image/mask_icon.png" />
          近7天告警
        </div>
        <div class="detail_table">
          <el-table class="tableSpec" :data="tableData">
            <el-table-column
              label="告警名称"
              prop="name"
              align="center"
            ></el-table-column>
            <el-table-column label="告警状态" prop="name" align="center">
              <template slot-scope="scope">
                <div :class="scope.row.aaa ? 'warn_type' : 'warn_type'">已解除</div>
              </template>
            </el-table-column>
            <el-table-column
              label="告警时间"
              prop="name"
              align="center"
            ></el-table-column>
            <el-table-column
              label="解除时间"
              prop="name"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10]"
            :page-size="10"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheMask",
  data() {
    return {
      value: "",
      show: false,
      current: 0,
      companyList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      tableData: [{ name: "asd阿萨德e" }],
      total: 23,
    };
  },

  mounted() {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    tabsChange(index) {
      this.current = index;
    },
    closeMsk() {
      this.show = false;
    },
    open() {
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/viewport.scss";

.mask_main {
  position: fixed;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 20, 38, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  .mask_content {
    width: vw(1200);
    height: vh(738);
    background: rgba(0, 30, 58, 0.72);
    box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
    border: 2px solid rgba(103, 192, 255, 0.46);
    padding: 0 0 vh(20) vw(20);
    display: flex;
    justify-content: space-between;
    .mask_left {
      width: vw(400);
      display: flex;
      flex-direction: column;
      height: vh(718);
      padding-top: vh(20);
      .search_box {
        height: vh(36);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: vh(20);
      }
      .company_box {
        height: calc(100% - vh(56));
        width: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        .company_list:last-of-type {
          margin-bottom: 0;
        }
        .company_list {
          width: calc(100%);
          height: vh(156);
          box-sizing: border-box;
          margin-bottom: vh(10);
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          padding-left: vw(20);
          &.active {
            background: url("@/assets/image/c_bg.png") no-repeat center;
            background-size: 100% 100%;
          }
          &.normal {
            border: 1px solid;
            border-image: linear-gradient(
                137deg,
                rgba(
                  32.439159527421,
                  130.02996504306793,
                  209.4642922282219,
                  0.6399999856948853
                ),
                rgba(72.31312930583954, 108.52400064468384, 147.23214358091354, 1)
              )
              1 1;
          }
          .title {
            font-weight: 700;
            font-size: vw(18);
            color: #fff;
          }
          .desc {
            font-weight: 400;
            font-size: vw(16);
            color: #b8c6d3;
            span {
              color: #fff;
            }
          }
        }
      }
    }
    .mask_right {
      width: vw(760);
      height: 100%;
      .right_title {
        background: url("@/assets/image/mask_title.png") no-repeat center;
        background-size: 100% 100%;
        width: 100%;
        height: vh(42);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title_text {
          font-family: YouSheBiaoTiHei;
          font-weight: 400;
          font-size: vw(24);
          background: linear-gradient(90deg, #ffffff 0%, #4caeff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-left: vw(50);
        }
        .close {
          width: vw(26);
          height: vw(26);
          margin-right: vw(20);
        }
      }
      .detail_label {
        height: vh(24);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 700;
        font-size: vw(18);
        line-height: vh(24);
        color: #58baff;
        margin: vh(19) auto vh(10);
        .icon {
          width: vw(12);
          height: vw(12);
          margin-right: vw(6);
        }
      }
      .ele_detail {
        width: vw(660);
        height: vh(176);
        background: rgba(0, 30, 58, 0.72);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border: 1px solid rgba(103, 192, 255, 0.46);
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: vh(20) vw(40);
        .detail_left {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          .detail_info {
            font-weight: 400;
            font-size: vw(16);
            color: #b8c6d3;
            span {
              color: #fff;
            }
          }
        }
        .detail_photo {
          width: vw(200);
          height: vh(150);
        }
      }
      .detail_table {
        width: vw(700);
        height: vh(263);
        background: rgba(0, 30, 58, 0.72);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border: 1px solid rgba(103, 192, 255, 0.46);
        padding: vh(20);
        .tableSpec {
          width: vw(700);
          height: 100%;
        }
      }
      .page_box {
        height: vh(70);
        width: vw(740);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
::v-deep .search_box .el-input {
  border-radius: 4px;
  height: vh(36) !important;
  width: vw(280) !important;
  .el-input__inner {
    height: vh(36) !important;
    width: vw(280) !important;
    color: #fff;
    background: linear-gradient(
      134deg,
      rgba(0, 212, 255, 0.13) 0%,
      rgba(80, 176, 255, 0) 100%
    );
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #4dbbff;
  }
}

::v-deep .search_box .el-button {
  width: vw(80);
  height: vh(36);
  background: #24abff;
  border-radius: 4px;
  margin-left: vw(20);
}

::v-deep .search_box .el-input__inner::placeholder {
  font-weight: 400;
  font-size: vw(13);
  color: #93e4ff;
}
::v-deep .search_box .el-input__inner::-webkit-input-placeholder {
  font-weight: 400;
  font-size: vw(13);
  color: #93e4ff;
}
::v-deep .search_box .el-input__inner:-moz-placeholder {
  font-weight: 400;
  font-size: vw(13);
  color: #93e4ff;
}
::v-deep .search_box .el-input__inner:-ms-input-placeholder {
  font-weight: 400;
  font-size: vw(13);
  color: #93e4ff;
}

.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
::deep(.el-table) {
  background-color: transparent;
}
::deep(.el-table__expanded-cell) {
  background-color: transparent;
}
::deep(.el-table th) {
  color: #00ffff;
  border-top: 1px solid #58bfff;
  background-color: transparent !important;
}
::deep(.el-table tr) {
  background-color: transparent !important;
  color: #ffffff;
}
::deep(.el-table td) {
  background-color: transparent !important;
}
.el-table__fixed::before {
  background-color: transparent;
}

::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff !important;
}
::v-deep .el-table::before {
  background-color: transparent !important;
}
::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}

::v-deep .el-pagination__total {
  font-weight: 400;
  font-size: vw(16);
  color: #fff;
}

::v-deep .page_box .el-input {
  height: 46.15% !important;
  border-radius: 4px;
  .el-input__inner {
    height: vh(30);
    border-radius: 2px;
    border: 1px solid #fff;
    background: transparent !important;
  }
}
.warn_type {
  width: vw(62);
  height: vh(24);
  background: url("@/assets/image/success_icon.png") no-repeat center;
  background-size: 100% 100%;
  margin: auto;
  text-align: center;
  line-height: vh(24);
}

::v-deep .page_box .el-input__inner {
  font-weight: 400;
  font-size: vw(15);
  color: #fff;
}
::v-deep .btn-prev {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .btn-next {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-pager .number {
  border-radius: 2px !important;
  border: 1px solid #ffffff !important;
  background: transparent !important;
  color: #fff !important;
  &.active {
    background: #0f77af !important;
  }
}
::v-deep .el-pagination__jump {
  color: #fff !important;
}
</style>
